module.exports = {
  channelName: 'Название канала',
  simQueryPlaceholder: 'Введите название канала',
  shippingType: 'Способ доставки',
  destinationDistribution: 'Способ доставки в пункт назначения',
  chargingMethod: 'Метод тарификации',
  acceptableGoods: 'Принимаемые грузы',
  settlementWeightRoundingRules: 'Правило округления веса для расчётов',
  creator: 'Создатель',
  bubbleCountingRatio: 'Коэффициент объёмного веса',
  bubbleSplittingRatio: 'Доля распределения объёма',
  multipleBoxesCalculationRules: 'Правила расчёта для нескольких коробок',
  singleBoxLowestBillableWeight: 'Минимальный тарифный вес одной коробки',
  newChannel: 'Добавить канал',
  editChannel: 'Редактировать канал',
  lookChannel: 'Просмотр канала',
  weightInfo: 'Информация о весовом расчёте',
  channelNameNoEmpty: 'Название канала не может быть пустым!',
  shippingTypeNoEmpty: 'Способ доставки не может быть пустым!',
  destinationDistributionNoEmpty: 'Способ доставки в пункт назначения не может быть пустым!',
  chargingMethodNoEmpty: 'Метод тарификации не может быть пустым!',
  bubbleCountingRatioNoEmpty: 'Коэффициент объёмного веса не может быть пустым!',
  bubbleSplittingRatioNoEmpty: 'Доля распределения объёма не может быть пустой!',
  singleBoxLowestBillableWeightNoEmpty: 'Минимальный тарифный вес одной коробки не может быть пустым!',
  multipleBoxesCalculationRulesNoEmpty: 'Правила расчёта для нескольких коробок не могут быть пустыми!',
  settlementWeightRoundingRulesNoEmpty: 'Правило округления веса для расчётов не может быть пустым!',
  acceptableGoodsNoEmpty: 'Выберите хотя бы один принимаемый груз!',
  editExistChannel: 'По каналу уже сформирован счёт-предложение. Обновить связанную информацию в счёте-предложении?',
  notEditName: 'Этот канал уже используется в счёте-предложении, изменение названия невозможно.',
  activeState: 'Статус активации',
  enable: 'Активировать',
  disable: 'Деактивировать',
  enableSucceed: 'Канал успешно активирован!',
  disableSucceed: 'Канал успешно деактивирован!',
  cannotActive: 'Нет данных для изменения.',
  exportQuotation: 'Экспорт предложения',
  printQuotation: 'Печать предложений',
  quotationValidityPeriod: 'Срок действия предложения',
  quotationLabel: 'Теги котировок',
  previewQuotation: 'Предварительный просмотр предложения',
  longTerm: 'Долгосрочная эффективность',
  addOrder: 'Дополнительный заказ',
  revokeTheApprovalForm: 'Отзыв сертификата',
  revokeOutboundShipment: 'Снятие со склада',
  containerNo: 'Номер контейнера',
  cannotDelete: 'Удаление канала, по которому сформирован счёт-предложение, запрещено!'
}
